import MobileHelpButton from 'components/MobileHelpButton';
import { useJobContext } from 'pages/Job/context';

import MobileActionButtons from './MobileActionButtons';

const MobileButtons: React.FunctionComponent = function () {
  const { page } = useJobContext();
  if (page === 'QUOTE') return <MobileActionButtons />;
  if (page === 'CHECKOUT') return <MobileHelpButton />;
  return null;
};

export default MobileButtons;
